import { Country } from './Enums';


// Pasarelas que puede devolver el backend en GetPaymentGateway.
// El valor lo decide el servidor por configuración: el cliente nunca debe
// inferirlo del país.
export enum PaymentGatewayType {
    Onvo = 'ONVO',
    Stripe = 'STP',
}

// Configuración de cobro del país: qué pasarela cobra, en qué moneda y cuál es
// el costo fijo del servicio. Espejo de PaymentGatewayDto del backend.
export class PaymentGatewayModel {

    public constructor(init?: Partial<Pick<PaymentGatewayModel, keyof PaymentGatewayModel>>) {

        if (init) {
            Object.assign(this, init);
        }
    }

    country: Country;

    // 'Onvo' | 'STP'. Se compara siempre por los getters de abajo, nunca por país.
    gateway: string;

    // Código ISO de la moneda de cobro (CRC, USD, NIO...)
    currency: string;

    currencySymbol: string;

    // Costo fijo del servicio en la moneda de cobro
    serviceCost = 0;

    // La tarjeta se tokeniza en el cliente con Stripe.js: el número nunca viaja
    // al backend. Con ONVO el backend recibe el número y tokeniza él.
    get isStripe(): boolean {

        return this.gateway?.trim().toUpperCase() == PaymentGatewayType.Stripe;
    }
}
